import React, { useContext } from "react";
import {
  QC_REVIEW_SUBTABS_ID,
  QC_REVIEW_TABS,
  QC_REVIEW_TABS_ALLOWED_ROLES,
  USERTYPES,
} from "../../../../constants/Constants";
import studylistContext from "../../../../context/studylist/StudylistContext";
import { Pivot, PivotItem } from "@fluentui/react";
import { t } from "i18next";
import themeContext from "../../../../context/theme/ThemeContext";
import userContext from "../../../../context/users/UserContext";

const QCReviewTabs = () => {
  const { roles, selectedValue, handleQCReviewTabChange } =
    useContext(studylistContext);
  const { getThemeColor } = useContext(themeContext);
  const { qcReviewer, contextSwitchUser } = useContext(userContext);

  const showQcReviewSubtabs =
    !contextSwitchUser &&
    QC_REVIEW_SUBTABS_ID.includes(selectedValue) &&
    QC_REVIEW_TABS_ALLOWED_ROLES.includes(roles[0]) &&
       roles[0] === USERTYPES.SUPERVISOR && qcReviewer == 1;

  const loadSelectedQCReviewTab = (item) => {
    if (item.props.itemKey === "qcreviewAssigned") {
      handleQCReviewTabChange(
        item.props.itemKey,
        QC_REVIEW_TABS.qcreviewAssigned,
        "study_24"
      );
    } else if (item.props.itemKey === "qcreview") {
      handleQCReviewTabChange(item.props.itemKey, QC_REVIEW_TABS.qcreview, "study_5");
    }
  };

  const getDefaultTab = () => {
    if (selectedValue === "study_24") {
      return "qcreviewAssigned";
    }
    if (selectedValue === "study_5") {
      return "qcreview";
    }
    return "qcreviewAssigned";
  };

  return (
    <>
      {showQcReviewSubtabs && (
        <div
          style={{
            position: "relative",
            borderLeft: getThemeColor("border"),
            borderTop: getThemeColor("border"),
          }}
          className="xray-tabs-pivot-top"
        >
          <div className="study-list-hide-cxr-border-top"></div>
          <Pivot
            className="xray-tabs-pivot"
            aria-label="QC Review tabs"
            linkSize="small"
            linkFormat={"tabs"}
            selectedKey={getDefaultTab()}
            onLinkClick={(item) => loadSelectedQCReviewTab(item)}
          >
            <PivotItem
              headerText={t("study-list.tabs.assigned-to-me")}
              itemKey="qcreviewAssigned"
            ></PivotItem>
            <PivotItem
              headerText={t("study-list.tabs.all-studies")}
              itemKey="qcreview"
            ></PivotItem>
          </Pivot>
        </div>
      )}
    </>
  );
};

export default QCReviewTabs;
